export default [
	'Anchored',
	'Anchored - Grocery',
	'Mall',
	'Mix-Use',
	'Power Center',
	'Retail Strip',
	'Shadow Anchored',
];